export const tokens = {
    search: {
        size: 16,
    },
    clear: {
        size: 20,
        icon: 10,
    },
};
